<template>
  <router-link :to="`/event-inspection/${data.eventType}`">{{data.eventType}}</router-link>
</template>

<script>
export default {
  name: "tableEventTypeSelector",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    test(id) {
      console.log(id);
    },
  },
};
</script>
